function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Tiktok = function Tiktok(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 40 40",
    a11yTitle: "Tiktok"
  }, props), React.createElement("path", {
    d: "M34.01,16.99c-0.27,0.03-0.54,0.04-0.81,0.04c-2.96,0-5.73-1.49-7.35-3.97v13.53c0,5.52-4.48,10-10,10s-10-4.48-10-10 s4.48-10,10-10l0,0c0.21,0,0.41,0.02,0.62,0.03v4.93c-0.21-0.02-0.41-0.06-0.62-0.06c-2.82,0-5.1,2.28-5.1,5.1 c0,2.82,2.28,5.1,5.1,5.1c2.82,0,5.31-2.22,5.31-5.04l0.05-22.98h4.71c0.44,4.23,3.85,7.53,8.09,7.84L34.01,16.99"
  }));
};